/* eslint-disable quote-props */
export default {
  "01.0000": "Agriculture, General",
  "01.0101": "Agricultural Business and Management, General",
  "01.0102": "Agribusiness/Agricultural Business Operations",
  "01.0103": "Agricultural Economics",
  "01.0104": "Farm/Farm and Ranch Management",
  "01.0105": "Agricultural/Farm Supplies Retailing and Wholesaling",
  "01.0106": "Agricultural Business Technology",
  "01.0199": "Agricultural Business and Management, Other",
  "01.0201": "Agricultural Mechanization, General",
  "01.0204": "Agricultural Power Machinery Operation",
  "01.0205": "Agricultural Mechanics and Equipment/Machine Technology",
  "01.0299": "Agricultural Mechanization, Other",
  "01.0301": "Agricultural Production Operations, General",
  "01.0302": "Animal/Livestock Husbandry and Production",
  "01.0303": "Aquaculture",
  "01.0304": "Crop Production",
  "01.0306": "Dairy Husbandry and Production",
  "01.0307": "Horse Husbandry/Equine Science and Management",
  "01.0308": "Agroecology and Sustainable Agriculture",
  "01.0309": "Viticulture and Enology",
  "01.0399": "Agricultural Production Operations, Other",
  "01.0401": "Agricultural and Food Products Processing",
  "01.0504": "Dog/Pet/Animal Grooming",
  "01.0505": "Animal Training",
  "01.0507": "Equestrian/Equine Studies",
  "01.0508": "Taxidermy/Taxidermist",
  "01.0599": "Agricultural and Domestic Animal Services, Other",
  "01.0601": "Applied Horticulture/Horticulture Operations, General",
  "01.0603": "Ornamental Horticulture",
  "01.0604": "Greenhouse Operations and Management",
  "01.0605": "Landscaping and Groundskeeping",
  "01.0606": "Plant Nursery Operations and Management",
  "01.0607": "Turf and Turfgrass Management",
  "01.0608": "Floriculture/Floristry Operations and Management",
  "01.0699": "Applied Horticulture/Horticultural Business Services, Other",
  "01.0701": "International Agriculture",
  "01.0801": "Agricultural and Extension Education Services",
  "01.0802": "Agricultural Communication/Journalism",
  "01.0899": "Agricultural Public Services, Other",
  "01.0901": "Animal Sciences, General",
  "01.0902": "Agricultural Animal Breeding",
  "01.0903": "Animal Health",
  "01.0904": "Animal Nutrition",
  "01.0905": "Dairy Science",
  "01.0906": "Livestock Management",
  "01.0907": "Poultry Science",
  "01.0999": "Animal Sciences, Other",
  "01.1001": "Food Science",
  "01.1002": "Food Technology and Processing",
  "01.1099": "Food Science and Technology, Other",
  "01.1101": "Plant Sciences, General",
  "01.1102": "Agronomy and Crop Science",
  "01.1103": "Horticultural Science",
  "01.1104": "Agricultural and Horticultural Plant Breeding",
  "01.1105": "Plant Protection and Integrated Pest Management",
  "01.1106": "Range Science and Management",
  "01.1199": "Plant Sciences, Other",
  "01.1201": "Soil Science and Agronomy, General",
  "01.1202": "Soil Chemistry and Physics",
  "01.1203": "Soil Microbiology",
  "01.1299": "Soil Sciences, Other",
  "01.9999": "Agriculture, Agriculture Operations, and Related Sciences, Other",
  "03.0101": "Natural Resources/Conservation, General",
  "03.0103": "Environmental Studies",
  "03.0104": "Environmental Science",
  "03.0199": "Natural Resources Conservation and Research, Other",
  "03.0201": "Natural Resources Management and Policy",
  "03.0204": "Natural Resource Economics",
  "03.0205": "Water, Wetlands, and Marine Resources Management",
  "03.0206": "Land Use Planning and Management/Development",
  "03.0207": "Natural Resource Recreation and Tourism",
  "03.0208": "Natural Resources Law Enforcement and Protective Services",
  "03.0299": "Natural Resources Management and Policy, Other",
  "03.0301": "Fishing and Fisheries Sciences and Management",
  "03.0501": "Forestry, General",
  "03.0502": "Forest Sciences and Biology",
  "03.0506": "Forest Management/Forest Resources Management",
  "03.0508": "Urban Forestry",
  "03.0509": "Wood Science and Wood Products/Pulp and Paper Technology",
  "03.0510": "Forest Resources Production and Management",
  "03.0511": "Forest Technology/Technician",
  "03.0599": "Forestry, Other",
  "03.0601": "Wildlife, Fish and Wildlands Science and Management",
  "03.9999": "Natural Resources and Conservation, Other",
  "04.0201": "Architecture",
  "04.0301": "City/Urban, Community and Regional Planning",
  "04.0401": "Environmental Design/Architecture",
  "04.0501": "Interior Architecture",
  "04.0601": "Landscape Architecture",
  "04.0801": "Architectural History and Criticism, General",
  "04.0901": "Architectural Technology/Technician",
  "04.0902": "Architectural and Building Sciences/Technology",
  "04.0999": "Architectural Sciences and Technology, Other",
  "04.1001": "Real Estate Development",
  "04.9999": "Architecture and Related Services, Other",
  "05.0101": "African Studies",
  "05.0102": "American/United States Studies/Civilization",
  "05.0103": "Asian Studies/Civilization",
  "05.0104": "East Asian Studies",
  "05.0105": "Russian, Central European, East European and Eurasian Studies",
  "05.0106": "European Studies/Civilization",
  "05.0107": "Latin American Studies",
  "05.0108": "Near and Middle Eastern Studies",
  "05.0109": "Pacific Area/Pacific Rim Studies",
  "05.0110": "Russian Studies",
  "05.0111": "Scandinavian Studies",
  "05.0112": "South Asian Studies",
  "05.0113": "Southeast Asian Studies",
  "05.0114": "Western European Studies",
  "05.0115": "Canadian Studies",
  "05.0116": "Balkans Studies",
  "05.0117": "Baltic Studies",
  "05.0118": "Slavic Studies",
  "05.0119": "Caribbean Studies",
  "05.0120": "Ural-Altaic and Central Asian Studies",
  "05.0121": "Commonwealth Studies",
  "05.0122": "Regional Studies (U.S., Canadian, Foreign)",
  "05.0123": "Chinese Studies",
  "05.0124": "French Studies",
  "05.0125": "German Studies",
  "05.0126": "Italian Studies",
  "05.0127": "Japanese Studies",
  "05.0128": "Korean Studies",
  "05.0129": "Polish Studies",
  "05.0130": "Spanish and Iberian Studies",
  "05.0131": "Tibetan Studies",
  "05.0132": "Ukraine Studies",
  "05.0133": "Irish Studies",
  "05.0134": "Latin American and Caribbean Studies",
  "05.0199": "Area Studies, Other",
  "05.0200": "Ethnic Studies",
  "05.0201": "African-American/Black Studies",
  "05.0202": "American Indian/Native American Studies",
  "05.0203":
    "Hispanic-American, Puerto Rican, and Mexican-American/Chicano Studies",
  "05.0206": "Asian-American Studies",
  "05.0207": "Women's Studies",
  "05.0208": "Gay/Lesbian Studies",
  "05.0209": "Folklore Studies",
  "05.0210": "Disability Studies",
  "05.0211": "Deaf Studies",
  "05.0299": "Ethnic, Cultural Minority, Gender, and Group Studies, Other",
  "09.0100": "Communication, General",
  "09.0101": "Speech Communication and Rhetoric",
  "09.0102": "Mass Communication/Media Studies",
  "09.0199": "Communication and Media Studies, Other",
  "09.0401": "Journalism",
  "09.0402": "Broadcast Journalism",
  "09.0404": "Photojournalism",
  "09.0499": "Journalism, Other",
  "09.0701": "Radio and Television",
  "09.0702": "Digital Communication and Media/Multimedia",
  "09.0799": "Radio, Television, and Digital Communication, Other",
  "09.0900": "Public Relations, Advertising, and Applied Communication",
  "09.0901": "Organizational Communication, General",
  "09.0902": "Public Relations/Image Management",
  "09.0903": "Advertising",
  "09.0904": "Political Communication",
  "09.0905": "Health Communication",
  "09.0906": "Sports Communication",
  "09.0907": "International and Intercultural Communication",
  "09.0908": "Technical and Scientific Communication",
  "09.0999": "Public Relations, Advertising, and Applied Communication, Other",
  "09.1001": "Publishing",
  "09.9999": "Communication, Journalism, and Related Programs, Other",
  "10.0105": "Communications Technology/Technician",
  "10.0201": "Photographic and Film/Video Technology/Technician and Assistant",
  "10.0202": "Radio and Television Broadcasting Technology/Technician",
  "10.0203": "Recording Arts Technology/Technician",
  "10.0299": "Audiovisual Communications Technologies/Technicians, Other",
  "10.0301": "Graphic Communications, General",
  "10.0302": "Printing Management",
  "10.0303": "Prepress/Desktop Publishing and Digital Imaging Design",
  "10.0304":
    "Animation, Interactive Technology, Video Graphics and Special Effects",
  "10.0305": "Graphic and Printing Equipment Operator, General Production",
  "10.0306": "Platemaker/Imager",
  "10.0307": "Printing Press Operator",
  "10.0308": "Computer Typography and Composition Equipment Operator",
  "10.0399": "Graphic Communications, Other",
  "10.9999":
    "Communications Technologies/Technicians and Support Services, Other",
  "11.0101": "Computer and Information Sciences, General",
  "11.0102": "Artificial Intelligence",
  "11.0103": "Information Technology",
  "11.0104": "Informatics",
  "11.0199": "Computer and Information Sciences,  Other",
  "11.0201": "Computer Programming/Programmer, General",
  "11.0202": "Computer Programming, Specific Applications",
  "11.0203": "Computer Programming, Vendor/Product Certification",
  "11.0299": "Computer Programming, Other",
  "11.0301": "Data Processing and Data Processing Technology/Technician",
  "11.0401": "Information Science/Studies",
  "11.0501": "Computer Systems Analysis/Analyst",
  "11.0601": "Data Entry/Microcomputer Applications, General",
  "11.0602": "Word Processing",
  "11.0699": "Data Entry/Microcomputer Applications, Other",
  "11.0701": "Computer Science",
  "11.0801": "Web Page, Digital/Multimedia and Information Resources Design",
  "11.0802": "Data Modeling/Warehousing and Database Administration",
  "11.0803": "Computer Graphics",
  "11.0804": "Modeling, Virtual Environments and Simulation",
  "11.0899": "Computer Software and Media Applications, Other",
  "11.0901": "Computer Systems Networking and Telecommunications",
  "11.1001": "Network and System Administration/Administrator",
  "11.1002": "System, Networking, and LAN/WAN Management/Manager",
  "11.1003": "Computer and Information Systems Security/Information Assurance",
  "11.1004": "Web/Multimedia Management and Webmaster",
  "11.1005": "Information Technology Project Management",
  "11.1006": "Computer Support Specialist",
  "11.1099":
    "Computer/Information Technology Services Administration and Management, Other",
  "11.9999": "Computer and Information Sciences and Support Services, Other",
  "12.0301": "Funeral Service and Mortuary Science, General",
  "12.0302": "Funeral Direction/Service",
  "12.0303": "Mortuary Science and Embalming/Embalmer",
  "12.0399": "Funeral Service and Mortuary Science, Other",
  "12.0401": "Cosmetology/Cosmetologist, General",
  "12.0402": "Barbering/Barber",
  "12.0404": "Electrolysis/Electrology and Electrolysis Technician",
  "12.0406": "Make-Up Artist/Specialist",
  "12.0407": "Hair Styling/Stylist and Hair Design",
  "12.0408": "Facial Treatment Specialist/Facialist",
  "12.0409": "Aesthetician/Esthetician and Skin Care Specialist",
  "12.0410": "Nail Technician/Specialist and Manicurist",
  "12.0411": "Permanent Cosmetics/Makeup and Tattooing",
  "12.0412": "Salon/Beauty Salon Management/Manager",
  "12.0413": "Cosmetology, Barber/Styling, and Nail Instructor",
  "12.0414": "Master Aesthetician/Esthetician",
  "12.0499": "Cosmetology and Related Personal Grooming Arts, Other",
  "12.0500": "Cooking and Related Culinary Arts, General",
  "12.0501": "Baking and Pastry Arts/Baker/Pastry Chef",
  "12.0502": "Bartending/Bartender",
  "12.0503": "Culinary Arts/Chef Training",
  "12.0504": "Restaurant, Culinary, and Catering Management/Manager",
  "12.0505": "Food Preparation/Professional Cooking/Kitchen Assistant",
  "12.0506": "Meat Cutting/Meat Cutter",
  "12.0507":
    "Food Service, Waiter/Waitress, and Dining Room Management/Manager",
  "12.0508": "Institutional Food Workers",
  "12.0509": "Culinary Science/Culinology",
  "12.0510": "Wine Steward/Sommelier",
  "12.0599": "Culinary Arts and Related Services, Other",
  "12.9999": "Personal and Culinary Services, Other",
  "13.0101": "Education, General",
  "13.0201": "Bilingual and Multilingual Education",
  "13.0202": "Multicultural Education",
  "13.0203": "Indian/Native American Education",
  "13.0299": "Bilingual, Multilingual, and Multicultural Education, Other",
  "13.0301": "Curriculum and Instruction",
  "13.0401": "Educational Leadership and Administration, General",
  "13.0402": "Administration of Special Education",
  "13.0403": "Adult and Continuing Education Administration",
  "13.0404": "Educational, Instructional, and Curriculum Supervision",
  "13.0406": "Higher Education/Higher Education Administration",
  "13.0407": "Community College Education",
  "13.0408": "Elementary and Middle School Administration/Principalship",
  "13.0409": "Secondary School Administration/Principalship",
  "13.0410": "Urban Education and Leadership",
  "13.0411": "Superintendency and Educational System Administration",
  "13.0499": "Educational Administration and Supervision, Other",
  "13.0501": "Educational/Instructional Technology",
  "13.0601": "Educational Evaluation and Research",
  "13.0603": "Educational Statistics and Research Methods",
  "13.0604": "Educational Assessment, Testing, and Measurement",
  "13.0607": "Learning Sciences",
  "13.0699": "Educational Assessment, Evaluation, and Research, Other",
  "13.0701": "International and Comparative Education",
  "13.0901": "Social and Philosophical Foundations of Education",
  "13.1001": "Special Education and Teaching, General",
  "13.1003":
    "Education/Teaching of Individuals with Hearing Impairments Including Deafness",
  "13.1004": "Education/Teaching of the Gifted and Talented",
  "13.1005": "Education/Teaching of Individuals with Emotional Disturbances",
  "13.1006": "Education/Teaching of Individuals with Mental Retardation",
  "13.1007": "Education/Teaching of Individuals with Multiple Disabilities",
  "13.1008":
    "Education/Teaching of Individuals with Orthopedic and Other Physical Health Impairments",
  "13.1009":
    "Education/Teaching of Individuals with Vision Impairments Including Blindness",
  "13.1011":
    "Education/Teaching of Individuals with Specific Learning Disabilities",
  "13.1012":
    "Education/Teaching of Individuals with Speech or Language Impairments",
  "13.1013": "Education/Teaching of Individuals with Autism",
  "13.1014":
    "Education/Teaching of Individuals Who are Developmentally Delayed",
  "13.1015":
    "Education/Teaching of Individuals in Early Childhood Special Education Programs",
  "13.1016": "Education/Teaching of Individuals with Traumatic Brain Injuries",
  "13.1017":
    "Education/Teaching of Individuals in Elementary Special Education Programs",
  "13.1018":
    "Education/Teaching of Individuals in Junior High/Middle School Special Education Programs",
  "13.1019":
    "Education/Teaching of Individuals in Secondary Special Education Programs",
  "13.1099": "Special Education and Teaching, Other",
  "13.1101": "Counselor Education/School Counseling and Guidance Services",
  "13.1102": "College Student Counseling and Personnel Services",
  "13.1199": "Student Counseling and Personnel Services, Other",
  "13.1201": "Adult and Continuing Education and Teaching",
  "13.1202": "Elementary Education and Teaching",
  "13.1203": "Junior High/Intermediate/Middle School Education and Teaching",
  "13.1205": "Secondary Education and Teaching",
  "13.1206": "Teacher Education, Multiple Levels",
  "13.1207": "Montessori Teacher Education",
  "13.1208": "Waldorf/Steiner Teacher Education",
  "13.1209": "Kindergarten/Preschool Education and Teaching",
  "13.1210": "Early Childhood Education and Teaching",
  "13.1299":
    "Teacher Education and Professional Development, Specific Levels and Methods, Other",
  "13.1301": "Agricultural Teacher Education",
  "13.1302": "Art Teacher Education",
  "13.1303": "Business Teacher Education",
  "13.1304": "Driver and Safety Teacher Education",
  "13.1305": "English/Language Arts Teacher Education",
  "13.1306": "Foreign Language Teacher  Education",
  "13.1307": "Health Teacher Education",
  "13.1308": "Family and Consumer Sciences/Home Economics Teacher Education",
  "13.1309": "Technology Teacher Education/Industrial Arts Teacher Education",
  "13.1310":
    "Sales and Marketing Operations/Marketing and Distribution   Teacher Education",
  "13.1311": "Mathematics Teacher Education",
  "13.1312": "Music Teacher Education",
  "13.1314": "Physical Education Teaching and Coaching",
  "13.1315": "Reading Teacher Education",
  "13.1316": "Science Teacher Education/General Science Teacher Education",
  "13.1317": "Social Science Teacher Education",
  "13.1318": "Social Studies Teacher Education",
  "13.1319": "Technical Teacher Education",
  "13.1320": "Trade and Industrial Teacher Education",
  "13.1321": "Computer Teacher Education",
  "13.1322": "Biology Teacher Education",
  "13.1323": "Chemistry Teacher Education",
  "13.1324": "Drama and Dance Teacher Education",
  "13.1325": "French Language Teacher Education",
  "13.1326": "German Language Teacher Education",
  "13.1327": "Health Occupations Teacher Education",
  "13.1328": "History Teacher Education",
  "13.1329": "Physics Teacher Education",
  "13.1330": "Spanish Language Teacher Education",
  "13.1331": "Speech Teacher Education",
  "13.1332": "Geography Teacher Education",
  "13.1333": "Latin Teacher Education",
  "13.1334": "School Librarian/School Library Media Specialist",
  "13.1335": "Psychology Teacher Education",
  "13.1337": "Earth Science Teacher Education",
  "13.1338": "Environmental Education",
  "13.1399":
    "Teacher Education and Professional Development, Specific Subject Areas, Other",
  "13.1401":
    "Teaching English as a Second or Foreign Language/ESL Language Instructor",
  "13.1402": "Teaching French as a Second or Foreign Language",
  "13.1499":
    "Teaching English or French as a Second or Foreign Language, Other",
  "13.1501": "Teacher Assistant/Aide",
  "13.1502": "Adult Literacy Tutor/Instructor",
  "13.1599": "Teaching Assistants/Aides, Other",
  "13.9999": "Education, Other",
  "14.0101": "Engineering, General",
  "14.0102": "Pre-Engineering",
  "14.0201": "Aerospace, Aeronautical and Astronautical/Space Engineering",
  "14.0301": "Agricultural Engineering",
  "14.0401": "Architectural Engineering",
  "14.0501": "Bioengineering and Biomedical Engineering",
  "14.0601": "Ceramic Sciences and Engineering",
  "14.0701": "Chemical Engineering",
  "14.0702": "Chemical and Biomolecular Engineering",
  "14.0799": "Chemical Engineering, Other",
  "14.0801": "Civil Engineering, General",
  "14.0802": "Geotechnical and Geoenvironmental Engineering",
  "14.0803": "Structural Engineering",
  "14.0804": "Transportation and Highway Engineering",
  "14.0805": "Water Resources Engineering",
  "14.0899": "Civil Engineering, Other",
  "14.0901": "Computer Engineering, General",
  "14.0902": "Computer Hardware Engineering",
  "14.0903": "Computer Software Engineering",
  "14.0999": "Computer Engineering, Other",
  "14.1001": "Electrical and Electronics Engineering",
  "14.1003": "Laser and Optical Engineering",
  "14.1004": "Telecommunications Engineering",
  "14.1099": "Electrical, Electronics and Communications Engineering, Other",
  "14.1101": "Engineering Mechanics",
  "14.1201": "Engineering Physics/Applied Physics",
  "14.1301": "Engineering Science",
  "14.1401": "Environmental/Environmental Health Engineering",
  "14.1801": "Materials Engineering",
  "14.1901": "Mechanical Engineering",
  "14.2001": "Metallurgical Engineering",
  "14.2101": "Mining and Mineral Engineering",
  "14.2201": "Naval Architecture and Marine Engineering",
  "14.2301": "Nuclear Engineering",
  "14.2401": "Ocean Engineering",
  "14.2501": "Petroleum Engineering",
  "14.2701": "Systems Engineering",
  "14.2801": "Textile Sciences and Engineering",
  "14.3201": "Polymer/Plastics Engineering",
  "14.3301": "Construction Engineering",
  "14.3401": "Forest Engineering",
  "14.3501": "Industrial Engineering",
  "14.3601": "Manufacturing Engineering",
  "14.3701": "Operations Research",
  "14.3801": "Surveying Engineering",
  "14.3901": "Geological/Geophysical Engineering",
  "14.4001": "Paper Science and Engineering",
  "14.4101": "Electromechanical Engineering",
  "14.4201": "Mechatronics, Robotics, and Automation Engineering",
  "14.4301": "Biochemical Engineering",
  "14.4401": "Engineering Chemistry",
  "14.4501": "Biological/Biosystems Engineering",
  "14.9999": "Engineering, Other",
  "15.0000": "Engineering Technology, General",
  "15.0101": "Architectural Engineering Technology/Technician",
  "15.0201": "Civil Engineering Technology/Technician",
  "15.0303":
    "Electrical, Electronic and Communications Engineering Technology/Technician",
  "15.0304": "Laser and Optical Technology/Technician",
  "15.0305": "Telecommunications Technology/Technician",
  "15.0306": "Integrated Circuit Design",
  "15.0399":
    "Electrical and Electronic Engineering Technologies/Technicians, Other",
  "15.0401": "Biomedical Technology/Technician",
  "15.0403":
    "Electromechanical Technology/Electromechanical Engineering Technology",
  "15.0404": "Instrumentation Technology/Technician",
  "15.0405": "Robotics Technology/Technician",
  "15.0406": "Automation Engineer Technology/Technician",
  "15.0499":
    "Electromechanical and Instrumentation and Maintenance Technologies/Technicians, Other",
  "15.0501":
    "Heating, Ventilation, Air Conditioning and Refrigeration Engineering Technology/Technician",
  "15.0503": "Energy Management and Systems Technology/Technician",
  "15.0505": "Solar Energy Technology/Technician",
  "15.0506":
    "Water Quality and Wastewater Treatment Management and Recycling Technology/Technician",
  "15.0507": "Environmental Engineering Technology/Environmental Technology",
  "15.0508": "Hazardous Materials Management and Waste Technology/Technician",
  "15.0599": "Environmental Control Technologies/Technicians, Other",
  "15.0607": "Plastics and Polymer Engineering Technology/Technician",
  "15.0611": "Metallurgical Technology/Technician",
  "15.0612": "Industrial Technology/Technician",
  "15.0613": "Manufacturing Engineering Technology/Technician",
  "15.0614": "Welding Engineering Technology/Technician",
  "15.0615": "Chemical Engineering Technology/Technician",
  "15.0616": "Semiconductor Manufacturing Technology",
  "15.0699": "Industrial Production Technologies/Technicians, Other",
  "15.0701": "Occupational Safety and Health Technology/Technician",
  "15.0702": "Quality Control Technology/Technician",
  "15.0703": "Industrial Safety Technology/Technician",
  "15.0704": "Hazardous Materials Information Systems Technology/Technician",
  "15.0799": "Quality Control and Safety Technologies/Technicians, Other",
  "15.0801": "Aeronautical/Aerospace Engineering Technology/Technician",
  "15.0803": "Automotive Engineering Technology/Technician",
  "15.0805": "Mechanical Engineering/Mechanical Technology/Technician",
  "15.0899": "Mechanical Engineering Related Technologies/Technicians, Other",
  "15.0901": "Mining Technology/Technician",
  "15.0903": "Petroleum Technology/Technician",
  "15.0999": "Mining and Petroleum Technologies/Technicians, Other",
  "15.1001": "Construction Engineering Technology/Technician",
  "15.1102": "Surveying Technology/Surveying",
  "15.1103": "Hydraulics and Fluid Power Technology/Technician",
  "15.1199": "Engineering-Related Technologies, Other",
  "15.1201": "Computer Engineering Technology/Technician",
  "15.1202": "Computer Technology/Computer Systems Technology",
  "15.1203": "Computer Hardware Technology/Technician",
  "15.1204": "Computer Software Technology/Technician",
  "15.1299": "Computer Engineering Technologies/Technicians, Other",
  "15.1301": "Drafting and Design Technology/Technician, General",
  "15.1302": "CAD/CADD Drafting and/or Design Technology/Technician",
  "15.1303": "Architectural Drafting and Architectural CAD/CADD",
  "15.1304": "Civil Drafting and Civil Engineering CAD/CADD",
  "15.1305":
    "Electrical/Electronics Drafting and Electrical/Electronics CAD/CADD",
  "15.1306": "Mechanical Drafting and Mechanical Drafting CAD/CADD",
  "15.1399": "Drafting/Design Engineering Technologies/Technicians, Other",
  "15.1401": "Nuclear Engineering Technology/Technician",
  "15.1501": "Engineering/Industrial Management",
  "15.1502": "Engineering Design",
  "15.1503": "Packaging Science",
  "15.1599": "Engineering-Related Fields, Other",
  "15.1601": "Nanotechnology",
  "15.9999": "Engineering Technologies and Engineering-Related Fields, Other",
  "16.0101": "Foreign Languages and Literatures, General",
  "16.0102": "Linguistics",
  "16.0103": "Language Interpretation and Translation",
  "16.0104": "Comparative Literature",
  "16.0105": "Applied Linguistics",
  "16.0199":
    "Linguistic, Comparative, and Related Language Studies and Services, Other",
  "16.0201": "African Languages, Literatures, and Linguistics",
  "16.0300": "East Asian Languages, Literatures, and Linguistics, General",
  "16.0301": "Chinese Language and Literature",
  "16.0302": "Japanese Language and Literature",
  "16.0303": "Korean Language and Literature",
  "16.0304": "Tibetan Language and Literature",
  "16.0399": "East Asian Languages, Literatures, and Linguistics, Other",
  "16.0400": "Slavic Languages, Literatures, and Linguistics, General",
  "16.0401": "Baltic Languages, Literatures, and Linguistics",
  "16.0402": "Russian Language and Literature",
  "16.0404": "Albanian Language and Literature",
  "16.0405": "Bulgarian Language and Literature",
  "16.0406": "Czech Language and Literature",
  "16.0407": "Polish Language and Literature",
  "16.0408": "Bosnian, Serbian, and Croatian Languages and Literatures",
  "16.0409": "Slovak Language and Literature",
  "16.0410": "Ukrainian Language and Literature",
  "16.0499":
    "Slavic, Baltic, and Albanian Languages, Literatures, and Linguistics, Other",
  "16.0500": "Germanic Languages, Literatures, and Linguistics, General",
  "16.0501": "German Language and Literature",
  "16.0502": "Scandinavian Languages, Literatures, and Linguistics",
  "16.0503": "Danish Language and Literature",
  "16.0504": "Dutch/Flemish Language and Literature",
  "16.0505": "Norwegian Language and Literature",
  "16.0506": "Swedish Language and Literature",
  "16.0599": "Germanic Languages, Literatures, and Linguistics, Other",
  "16.0601": "Modern Greek Language and Literature",
  "16.0700": "South Asian Languages, Literatures, and Linguistics, General",
  "16.0701": "Hindi Language and Literature",
  "16.0702":
    "Sanskrit and Classical Indian Languages, Literatures, and Linguistics",
  "16.0704": "Bengali Language and Literature",
  "16.0705": "Punjabi Language and Literature",
  "16.0706": "Tamil Language and Literature",
  "16.0707": "Urdu Language and Literature",
  "16.0799": "South Asian Languages, Literatures, and Linguistics, Other",
  "16.0801": "Iranian Languages, Literatures, and Linguistics",
  "16.0900": "Romance Languages, Literatures, and Linguistics, General",
  "16.0901": "French Language and Literature",
  "16.0902": "Italian Language and Literature",
  "16.0904": "Portuguese Language and Literature",
  "16.0905": "Spanish Language and Literature",
  "16.0906": "Romanian Language and Literature",
  "16.0907": "Catalan Language and Literature",
  "16.0908":
    "Hispanic and Latin American Languages, Literatures, and Linguistics, General",
  "16.0999": "Romance Languages, Literatures, and Linguistics, Other",
  "16.1001":
    "American Indian/Native American Languages, Literatures, and Linguistics",
  "16.1100":
    "Middle/Near Eastern and Semitic Languages, Literatures, and Linguistics, General",
  "16.1101": "Arabic Language and Literature",
  "16.1102": "Hebrew Language and Literature",
  "16.1103":
    "Ancient Near Eastern and Biblical Languages, Literatures, and Linguistics",
  "16.1199":
    "Middle/Near Eastern and Semitic Languages, Literatures, and Linguistics, Other",
  "16.1200":
    "Classics and Classical Languages, Literatures, and Linguistics, General",
  "16.1202": "Ancient/Classical Greek Language and Literature",
  "16.1203": "Latin Language and Literature",
  "16.1299":
    "Classics and Classical Languages, Literatures, and Linguistics, Other",
  "16.1301": "Celtic Languages, Literatures, and Linguistics",
  "16.1400": "Southeast Asian Languages, Literatures, and Linguistics, General",
  "16.1401":
    "Australian/Oceanic/Pacific Languages, Literatures, and Linguistics",
  "16.1402": "Indonesian/Malay Languages and Literatures",
  "16.1403": "Burmese Language and Literature",
  "16.1404": "Filipino/Tagalog Language and Literature",
  "16.1405": "Khmer/Cambodian Language and Literature",
  "16.1406": "Lao Language and Literature",
  "16.1407": "Thai Language and Literature",
  "16.1408": "Vietnamese Language and Literature",
  "16.1499":
    "Southeast Asian and Australasian/Pacific Languages, Literatures, and Linguistics, Other",
  "16.1501": "Turkish Language and Literature",
  "16.1502": "Uralic Languages, Literatures, and Linguistics",
  "16.1503": "Hungarian/Magyar Language and Literature",
  "16.1504": "Mongolian Language and Literature",
  "16.1599":
    "Turkic, Uralic-Altaic, Caucasian, and Central Asian Languages, Literatures, and Linguistics, Other",
  "16.1601": "American Sign Language (ASL)",
  "16.1602": "Linguistics of ASL and Other Sign Languages",
  "16.1603": "Sign Language Interpretation and Translation",
  "16.1699": "American Sign Language, Other",
  "16.9999": "Foreign Languages, Literatures, and Linguistics, Other",
  "19.0000": "Work and Family Studies",
  "19.0101": "Family and Consumer Sciences/Human Sciences, General",
  "19.0201": "Business Family and Consumer Sciences/Human Sciences",
  "19.0202": "Family and Consumer Sciences/Human Sciences Communication",
  "19.0203": "Consumer Merchandising/Retailing Management",
  "19.0299":
    "Family and Consumer Sciences/Human Sciences Business Services, Other",
  "19.0401": "Family Resource Management Studies, General",
  "19.0402": "Consumer Economics",
  "19.0403": "Consumer Services and Advocacy",
  "19.0499": "Family and Consumer Economics and Related Services, Other",
  "19.0501": "Foods, Nutrition, and Wellness Studies, General",
  "19.0504": "Human Nutrition",
  "19.0505": "Foodservice Systems Administration/Management",
  "19.0599": "Foods, Nutrition, and Related Services, Other",
  "19.0601": "Housing and Human Environments, General",
  "19.0604": "Facilities Planning and Management",
  "19.0605": "Home Furnishings and Equipment Installers",
  "19.0699": "Housing and Human Environments, Other",
  "19.0701": "Human Development and Family Studies, General",
  "19.0702": "Adult Development and Aging",
  "19.0704": "Family Systems",
  "19.0706": "Child Development",
  "19.0707": "Family and Community Services",
  "19.0708": "Child Care and Support Services Management",
  "19.0709": "Child Care Provider/Assistant",
  "19.0710": "Developmental Services Worker",
  "19.0799": "Human Development, Family Studies, and Related Services, Other",
  "19.0901": "Apparel and Textiles, General",
  "19.0902": "Apparel and Textile Manufacture",
  "19.0904": "Textile Science",
  "19.0905": "Apparel and Textile Marketing Management",
  "19.0906": "Fashion and Fabric Consultant",
  "19.0999": "Apparel and Textiles, Other",
  "19.9999": "Family and Consumer Sciences/Human Sciences, Other",
  "22.0000": "Legal Studies, General",
  "22.0001": "Pre-Law Studies",
  "22.0101": "Law",
  "22.0201": "Advanced Legal Research/Studies, General",
  "22.0202": "Programs for Foreign Lawyers",
  "22.0203": "American/U.S. Law/Legal Studies/Jurisprudence",
  "22.0204": "Canadian Law/Legal Studies/Jurisprudence",
  "22.0205": "Banking, Corporate, Finance, and Securities Law",
  "22.0206": "Comparative Law",
  "22.0207": "Energy, Environment, and Natural Resources Law",
  "22.0208": "Health Law",
  "22.0209": "International Law and Legal Studies",
  "22.0210": "International Business, Trade, and Tax Law",
  "22.0211": "Tax Law/Taxation",
  "22.0212": "Intellectual Property Law",
  "22.0299": "Legal Research and Advanced Professional Studies, Other",
  "22.0301": "Legal Administrative Assistant/Secretary",
  "22.0302": "Legal Assistant/Paralegal",
  "22.0303": "Court Reporting/Court Reporter",
  "22.0399": "Legal Support Services, Other",
  "22.9999": "Legal Professions and Studies, Other",
  "23.0101": "English Language and Literature, General",
  "23.1301": "Writing, General",
  "23.1302": "Creative Writing",
  "23.1303": "Professional, Technical, Business, and Scientific Writing",
  "23.1304": "Rhetoric and Composition",
  "23.1399": "Rhetoric and Composition/Writing Studies, Other",
  "23.1401": "General Literature",
  "23.1402": "American Literature (United States)",
  "23.1403": "American Literature (Canadian)",
  "23.1404": "English Literature (British and Commonwealth)",
  "23.1405": "Children's and Adolescent Literature",
  "23.1499": "Literature, Other",
  "23.9999": "English Language and Literature/Letters, Other",
  "24.0101": "Liberal Arts and Sciences/Liberal Studies",
  "24.0102": "General Studies",
  "24.0103": "Humanities/Humanistic Studies",
  "24.0199": "Liberal Arts and Sciences, General Studies and Humanities, Other",
  "25.0101": "Library and Information Science",
  "25.0102": "Children and Youth Library Services",
  "25.0103": "Archives/Archival Administration",
  "25.0199": "Library Science and Administration, Other",
  "25.0301": "Library and Archives Assisting",
  "25.9999": "Library Science, Other",
  "26.0101": "Biology/Biological Sciences, General",
  "26.0102": "Biomedical Sciences, General",
  "26.0202": "Biochemistry",
  "26.0203": "Biophysics",
  "26.0204": "Molecular Biology",
  "26.0205": "Molecular Biochemistry",
  "26.0206": "Molecular Biophysics",
  "26.0207": "Structural Biology",
  "26.0208": "Photobiology",
  "26.0209": "Radiation Biology/Radiobiology",
  "26.0210": "Biochemistry and Molecular Biology",
  "26.0299": "Biochemistry, Biophysics and Molecular Biology, Other",
  "26.0301": "Botany/Plant Biology",
  "26.0305": "Plant Pathology/Phytopathology",
  "26.0307": "Plant Physiology",
  "26.0308": "Plant Molecular Biology",
  "26.0399": "Botany/Plant Biology, Other",
  "26.0401": "Cell/Cellular Biology and Histology",
  "26.0403": "Anatomy",
  "26.0404": "Developmental Biology and Embryology",
  "26.0406": "Cell/Cellular and Molecular Biology",
  "26.0407": "Cell Biology and Anatomy",
  "26.0499": "Cell/Cellular Biology and Anatomical Sciences, Other",
  "26.0502": "Microbiology, General",
  "26.0503": "Medical Microbiology and Bacteriology",
  "26.0504": "Virology",
  "26.0505": "Parasitology",
  "26.0506": "Mycology",
  "26.0507": "Immunology",
  "26.0508": "Microbiology and Immunology",
  "26.0599": "Microbiological Sciences and Immunology, Other",
  "26.0701": "Zoology/Animal Biology",
  "26.0702": "Entomology",
  "26.0707": "Animal Physiology",
  "26.0708": "Animal Behavior and Ethology",
  "26.0709": "Wildlife Biology",
  "26.0799": "Zoology/Animal Biology, Other",
  "26.0801": "Genetics, General",
  "26.0802": "Molecular Genetics",
  "26.0803": "Microbial and Eukaryotic Genetics",
  "26.0804": "Animal Genetics",
  "26.0805": "Plant Genetics",
  "26.0806": "Human/Medical Genetics",
  "26.0807": "Genome Sciences/Genomics",
  "26.0899": "Genetics, Other",
  "26.0901": "Physiology, General",
  "26.0902": "Molecular Physiology",
  "26.0903": "Cell Physiology",
  "26.0904": "Endocrinology",
  "26.0905": "Reproductive Biology",
  "26.0907": "Cardiovascular Science",
  "26.0908": "Exercise Physiology",
  "26.0909": "Vision Science/Physiological Optics",
  "26.0910": "Pathology/Experimental Pathology",
  "26.0911": "Oncology and Cancer Biology",
  "26.0912": "Aerospace Physiology and Medicine",
  "26.0999": "Physiology, Pathology, and Related Sciences, Other",
  "26.1001": "Pharmacology",
  "26.1002": "Molecular Pharmacology",
  "26.1003": "Neuropharmacology",
  "26.1004": "Toxicology",
  "26.1005": "Molecular Toxicology",
  "26.1006": "Environmental Toxicology",
  "26.1007": "Pharmacology and Toxicology",
  "26.1099": "Pharmacology and Toxicology, Other",
  "26.1101": "Biometry/Biometrics",
  "26.1102": "Biostatistics",
  "26.1103": "Bioinformatics",
  "26.1104": "Computational Biology",
  "26.1199": "Biomathematics, Bioinformatics, and Computational Biology, Other",
  "26.1201": "Biotechnology",
  "26.1301": "Ecology",
  "26.1302": "Marine Biology and Biological Oceanography",
  "26.1303": "Evolutionary Biology",
  "26.1304": "Aquatic Biology/Limnology",
  "26.1305": "Environmental Biology",
  "26.1306": "Population Biology",
  "26.1307": "Conservation Biology",
  "26.1308": "Systematic Biology/Biological Systematics",
  "26.1309": "Epidemiology",
  "26.1310": "Ecology and Evolutionary Biology",
  "26.1399": "Ecology, Evolution, Systematics and Population Biology, Other",
  "26.1401": "Molecular Medicine",
  "26.1501": "Neuroscience",
  "26.1502": "Neuroanatomy",
  "26.1503": "Neurobiology and Anatomy",
  "26.1504": "Neurobiology and Behavior",
  "26.1599": "Neurobiology and Neurosciences, Other",
  "26.9999": "Biological and Biomedical Sciences, Other",
  "27.0101": "Mathematics, General",
  "27.0102": "Algebra and Number Theory",
  "27.0103": "Analysis and Functional Analysis",
  "27.0104": "Geometry/Geometric Analysis",
  "27.0105": "Topology and Foundations",
  "27.0199": "Mathematics, Other",
  "27.0301": "Applied Mathematics, General",
  "27.0303": "Computational Mathematics",
  "27.0304": "Computational and Applied Mathematics",
  "27.0305": "Financial Mathematics",
  "27.0306": "Mathematical Biology",
  "27.0399": "Applied Mathematics, Other",
  "27.0501": "Statistics, General",
  "27.0502": "Mathematical Statistics and Probability",
  "27.0503": "Mathematics and Statistics",
  "27.0599": "Statistics, Other",
  "27.9999": "Mathematics and Statistics, Other",
  "28.0101": "Air Force JROTC/ROTC",
  "28.0199": "Air Force ROTC, Air Science and Operations, Other",
  "28.0301": "Army JROTC/ROTC",
  "28.0399": "Army ROTC, Military Science and Operations, Other",
  "28.0401": "Navy/Marine Corps JROTC/ROTC",
  "28.0499": "Navy/Marine Corps ROTC, Naval Science and Operations, Other",
  "28.0501": "Air Science/Airpower Studies",
  "28.0502": "Air and Space Operational Art and Science",
  "28.0503": "Military Operational Art and Science/Studies",
  "28.0504": "Advanced Military and Operational Studies",
  "28.0505": "Naval Science and Operational Studies",
  "28.0506": "Special, Irregular and Counterterrorist Operations",
  "28.0599": "Military Science and Operational Studies, Other",
  "28.0601": "Strategic Studies, General",
  "28.0602": "Military and Strategic Leadership",
  "28.0603": "Military and International Operational Law",
  "28.0604": "Joint Operations Planning and Strategy",
  "28.0605": "Weapons of Mass Destruction",
  "28.0699": "National Security Policy and Strategy, Other",
  "28.0701": "National Resource Strategy and Policy",
  "28.0702": "Industry Studies",
  "28.0703": "Military Installation Management",
  "28.0799": "Military Economics and Management, Other",
  "28.9999": "Military Science, Leadership and Operational Art, Other",
  "29.0201": "Intelligence, General",
  "29.0202": "Strategic Intelligence",
  "29.0203": "Signal/Geospatial Intelligence",
  "29.0204": "Command & Control (C3, C4I) Systems and Operations",
  "29.0205": "Information Operations/Joint Information Operations",
  "29.0206": "Information/Psychological Warfare and Military Media Relations",
  "29.0207": "Cyber/Electronic Operations and Warfare",
  "29.0299": "Intelligence, Command Control and Information Operations, Other",
  "29.0301": "Combat Systems Engineering",
  "29.0302": "Directed Energy Systems",
  "29.0303": "Engineering Acoustics",
  "29.0304": "Low-Observables and Stealth Technology",
  "29.0305": "Space Systems Operations",
  "29.0306": "Operational Oceanography",
  "29.0307": "Undersea Warfare",
  "29.0399": "Military Applied Sciences, Other",
  "29.0401": "Aerospace Ground Equipment Technology",
  "29.0402": "Air and Space Operations Technology",
  "29.0403": "Aircraft Armament Systems Technology",
  "29.0404": "Explosive Ordinance/Bomb Disposal",
  "29.0405": "Joint Command/Task Force (C3, C4I) Systems",
  "29.0406": "Military Information Systems Technology",
  "29.0407": "Missile and Space Systems Technology",
  "29.0408": "Munitions Systems/Ordinance Technology",
  "29.0409": "Radar Communications and Systems Technology",
  "29.0499": "Military Systems and Maintenance Technology, Other",
  "29.9999": "Military Technologies and Applied Sciences, Other",
  "30.0000": "Multi-/Interdisciplinary Studies, General",
  "30.0101": "Biological and Physical Sciences",
  "30.0501": "Peace Studies and Conflict Resolution",
  "30.0601": "Systems Science and Theory",
  "30.0801": "Mathematics and Computer Science",
  "30.1001": "Biopsychology",
  "30.1101": "Gerontology",
  "30.1201": "Historic Preservation and Conservation",
  "30.1202": "Cultural Resource Management and Policy Analysis",
  "30.1299": "Historic Preservation and Conservation, Other",
  "30.1301": "Medieval and Renaissance Studies",
  "30.1401": "Museology/Museum Studies",
  "30.1501": "Science, Technology and Society",
  "30.1601": "Accounting and Computer Science",
  "30.1701": "Behavioral Sciences",
  "30.1801": "Natural Sciences",
  "30.1901": "Nutrition Sciences",
  "30.2001": "International/Global Studies",
  "30.2101": "Holocaust and Related Studies",
  "30.2201": "Ancient Studies/Civilization",
  "30.2202":
    "Classical, Ancient Mediterranean and Near Eastern Studies and Archaeology",
  "30.2301": "Intercultural/Multicultural and Diversity Studies",
  "30.2501": "Cognitive Science",
  "30.2601": "Cultural Studies/Critical Theory and Analysis",
  "30.2701": "Human Biology",
  "30.2801": "Dispute Resolution",
  "30.2901": "Maritime Studies",
  "30.3001": "Computational Science",
  "30.3101": "Human Computer Interaction",
  "30.3201": "Marine Sciences",
  "30.3301": "Sustainability Studies",
  "30.9999": "Multi-/Interdisciplinary Studies, Other",
  "31.0101": "Parks, Recreation and Leisure Studies",
  "31.0301": "Parks, Recreation and Leisure Facilities Management, General",
  "31.0302": "Golf Course Operation and Grounds Management",
  "31.0399": "Parks, Recreation and Leisure Facilities Management, Other",
  "31.0501": "Health and Physical Education/Fitness, General",
  "31.0504": "Sport and Fitness Administration/Management",
  "31.0505": "Kinesiology and Exercise Science",
  "31.0507": "Physical Fitness Technician",
  "31.0508": "Sports Studies",
  "31.0599": "Health and Physical Education/Fitness, Other",
  "31.0601": "Outdoor Education",
  "31.9999": "Parks, Recreation, Leisure, and Fitness Studies, Other",
  "32.0101": "Basic Skills and Developmental/Remedial Education, General",
  "32.0104": "Developmental/Remedial Mathematics",
  "32.0105": "Job-Seeking/Changing Skills",
  "32.0107": "Career Exploration/Awareness Skills",
  "32.0108": "Developmental/Remedial English",
  "32.0109": "Second Language Learning",
  "32.0110": "Basic Computer Skills",
  "32.0111": "Workforce Development and Training",
  "32.0199": "Basic Skills and Developmental/Remedial Education, Other",
  "33.0101": "Citizenship Activities, General",
  "33.0102": "American Citizenship Education",
  "33.0103": "Community Awareness",
  "33.0104": "Community Involvement",
  "33.0105": "Canadian Citizenship Education",
  "33.0199": "Citizenship Activities, Other",
  "34.0102": "Birthing and Parenting Knowledge and Skills",
  "34.0103": "Personal Health Improvement and Maintenance",
  "34.0104": "Addiction Prevention and Treatment",
  "34.0199": "Health-Related Knowledge and Skills, Other",
  "35.0101": "Interpersonal and Social Skills, General",
  "35.0102": "Interpersonal Relationships Skills",
  "35.0103": "Business and Social Skills",
  "35.0199": "Interpersonal Social Skills, Other",
  "36.0101": "Leisure and Recreational Activities, General",
  "36.0102": "Handicrafts and Model-Making",
  "36.0103": "Board, Card and Role-Playing Games",
  "36.0105": "Home Maintenance and Improvement",
  "36.0106": "Nature Appreciation",
  "36.0107": "Pet Ownership and Care",
  "36.0108": "Sports and Exercise",
  "36.0109": "Travel and Exploration",
  "36.0110": "Art",
  "36.0111": "Collecting",
  "36.0112": "Cooking and Other Domestic Skills",
  "36.0113": "Computer Games and Programming Skills",
  "36.0114": "Dancing",
  "36.0115": "Music",
  "36.0116": "Reading",
  "36.0117": "Theatre/Theater",
  "36.0118": "Writing",
  "36.0119": "Aircraft Pilot (Private)",
  "36.0199": "Leisure and Recreational Activities, Other",
  "37.0101": "Self-Awareness and Personal Assessment",
  "37.0102": "Stress Management and Coping Skills",
  "37.0103": "Personal Decision-Making Skills",
  "37.0104": "Self-Esteem and Values Clarification",
  "37.0199": "Personal Awareness and Self-Improvement, Other",
  "38.0001": "Philosophy and Religious Studies, General",
  "38.0101": "Philosophy",
  "38.0102": "Logic",
  "38.0103": "Ethics",
  "38.0104": "Applied and Professional Ethics",
  "38.0199": "Philosophy, Other",
  "38.0201": "Religion/Religious Studies",
  "38.0202": "Buddhist Studies",
  "38.0203": "Christian Studies",
  "38.0204": "Hindu Studies",
  "38.0205": "Islamic Studies",
  "38.0206": "Jewish/Judaic Studies",
  "38.0299": "Religion/Religious Studies, Other",
  "38.9999": "Philosophy and Religious Studies, Other",
  "39.0201": "Bible/Biblical Studies",
  "39.0301": "Missions/Missionary Studies and Missiology",
  "39.0401": "Religious Education",
  "39.0501": "Religious/Sacred Music",
  "39.0601": "Theology/Theological Studies",
  "39.0602": "Divinity/Ministry",
  "39.0604": "Pre-Theology/Pre-Ministerial Studies",
  "39.0605": "Rabbinical Studies",
  "39.0606": "Talmudic Studies",
  "39.0699": "Theological and Ministerial Studies, Other",
  "39.0701": "Pastoral Studies/Counseling",
  "39.0702": "Youth Ministry",
  "39.0703": "Urban Ministry",
  "39.0704": "Women's Ministry",
  "39.0705": "Lay Ministry",
  "39.0799": "Pastoral Counseling and Specialized Ministries, Other",
  "39.9999": "Theology and Religious Vocations, Other",
  "40.0101": "Physical Sciences",
  "40.0201": "Astronomy",
  "40.0202": "Astrophysics",
  "40.0203": "Planetary Astronomy and Science",
  "40.0299": "Astronomy and Astrophysics, Other",
  "40.0401": "Atmospheric Sciences and Meteorology, General",
  "40.0402": "Atmospheric Chemistry and Climatology",
  "40.0403": "Atmospheric Physics and Dynamics",
  "40.0404": "Meteorology",
  "40.0499": "Atmospheric Sciences and Meteorology, Other",
  "40.0501": "Chemistry, General",
  "40.0502": "Analytical Chemistry",
  "40.0503": "Inorganic Chemistry",
  "40.0504": "Organic Chemistry",
  "40.0506": "Physical Chemistry",
  "40.0507": "Polymer Chemistry",
  "40.0508": "Chemical Physics",
  "40.0509": "Environmental Chemistry",
  "40.0510": "Forensic Chemistry",
  "40.0511": "Theoretical Chemistry",
  "40.0599": "Chemistry, Other",
  "40.0601": "Geology/Earth Science, General",
  "40.0602": "Geochemistry",
  "40.0603": "Geophysics and Seismology",
  "40.0604": "Paleontology",
  "40.0605": "Hydrology and Water Resources Science",
  "40.0606": "Geochemistry and Petrology",
  "40.0607": "Oceanography, Chemical and Physical",
  "40.0699": "Geological and Earth Sciences/Geosciences, Other",
  "40.0801": "Physics, General",
  "40.0802": "Atomic/Molecular Physics",
  "40.0804": "Elementary Particle Physics",
  "40.0805": "Plasma and High-Temperature Physics",
  "40.0806": "Nuclear Physics",
  "40.0807": "Optics/Optical Sciences",
  "40.0808": "Condensed Matter and Materials Physics",
  "40.0809": "Acoustics",
  "40.0810": "Theoretical and Mathematical Physics",
  "40.0899": "Physics, Other",
  "40.1001": "Materials Science",
  "40.1002": "Materials Chemistry",
  "40.1099": "Materials Sciences, Other",
  "40.9999": "Physical Sciences, Other",
  "41.0000": "Science Technologies/Technicians, General",
  "41.0101": "Biology Technician/Biotechnology Laboratory Technician",
  "41.0204": "Industrial Radiologic Technology/Technician",
  "41.0205": "Nuclear/Nuclear Power Technology/Technician",
  "41.0299":
    "Nuclear and Industrial Radiologic Technologies/Technicians, Other",
  "41.0301": "Chemical Technology/Technician",
  "41.0303": "Chemical Process Technology",
  "41.0399": "Physical Science Technologies/Technicians, Other",
  "41.9999": "Science Technologies/Technicians, Other",
  "42.0101": "Psychology, General",
  "42.2701": "Cognitive Psychology and Psycholinguistics",
  "42.2702": "Comparative Psychology",
  "42.2703": "Developmental and Child Psychology",
  "42.2704": "Experimental Psychology",
  "42.2705": "Personality Psychology",
  "42.2706": "Physiological Psychology/Psychobiology",
  "42.2707": "Social Psychology",
  "42.2708": "Psychometrics and Quantitative Psychology",
  "42.2709": "Psychopharmacology",
  "42.2799": "Research and Experimental Psychology, Other",
  "42.2801": "Clinical Psychology",
  "42.2802": "Community Psychology",
  "42.2803": "Counseling Psychology",
  "42.2804": "Industrial and Organizational Psychology",
  "42.2805": "School Psychology",
  "42.2806": "Educational Psychology",
  "42.2807": "Clinical Child Psychology",
  "42.2808": "Environmental Psychology",
  "42.2809": "Geropsychology",
  "42.2810": "Health/Medical Psychology",
  "42.2811": "Family Psychology",
  "42.2812": "Forensic Psychology",
  "42.2813": "Applied Psychology",
  "42.2814": "Applied Behavior Analysis",
  "42.2899": "Clinical, Counseling and Applied Psychology, Other",
  "42.9999": "Psychology, Other",
  "43.0102": "Corrections",
  "43.0103": "Criminal Justice/Law Enforcement Administration",
  "43.0104": "Criminal Justice/Safety Studies",
  "43.0106": "Forensic Science and Technology",
  "43.0107": "Criminal Justice/Police Science",
  "43.0109": "Security and Loss Prevention Services",
  "43.0110": "Juvenile Corrections",
  "43.0111": "Criminalistics and Criminal Science",
  "43.0112": "Securities Services Administration/Management",
  "43.0113": "Corrections Administration",
  "43.0114": "Law Enforcement Investigation and Interviewing",
  "43.0115": "Law Enforcement Record-Keeping and Evidence Management",
  "43.0116": "Cyber/Computer Forensics and Counterterrorism",
  "43.0117": "Financial Forensics and Fraud Investigation",
  "43.0118": "Law Enforcement Intelligence Analysis",
  "43.0119": "Critical Incident Response/Special Police Operations",
  "43.0120": "Protective Services Operations",
  "43.0121": "Suspension and Debarment Investigation",
  "43.0122": "Maritime Law Enforcement",
  "43.0123": "Cultural/Archaelogical Resources Protection",
  "43.0199": "Corrections and Criminal Justice, Other",
  "43.0201": "Fire Prevention and Safety Technology/Technician",
  "43.0202": "Fire Services Administration",
  "43.0203": "Fire Science/Fire-fighting",
  "43.0204": "Fire Systems Technology",
  "43.0205": "Fire/Arson Investigation and Prevention",
  "43.0206": "Wildland/Forest Firefighting and Investigation",
  "43.0299": "Fire Protection, Other",
  "43.0301": "Homeland Security",
  "43.0302": "Crisis/Emergency/Disaster Management",
  "43.0303": "Critical Infrastructure Protection",
  "43.0304": "Terrorism and Counterterrorism Operations",
  "43.0399": "Homeland Security, Other",
  "43.9999":
    "Homeland Security, Law Enforcement, Firefighting and Related Protective Services, Other",
  "44.0000": "Human Services, General",
  "44.0201": "Community Organization and Advocacy",
  "44.0401": "Public Administration",
  "44.0501": "Public Policy Analysis, General",
  "44.0502": "Education Policy Analysis",
  "44.0503": "Health Policy Analysis",
  "44.0504": "International Policy Analysis",
  "44.0599": "Public Policy Analysis, Other",
  "44.0701": "Social Work",
  "44.0702": "Youth Services/Administration",
  "44.0799": "Social Work, Other",
  "44.9999": "Public Administration and Social Service Professions, Other",
  "45.0101": "Social Sciences, General",
  "45.0102": "Research Methodology and Quantitative Methods",
  "45.0201": "Anthropology",
  "45.0202": "Physical and Biological Anthropology",
  "45.0203": "Medical Anthropology",
  "45.0204": "Cultural Anthropology",
  "45.0299": "Anthropology, Other",
  "45.0301": "Archeology",
  "45.0401": "Criminology",
  "45.0501": "Demography and Population Studies",
  "45.0601": "Economics, General",
  "45.0602": "Applied Economics",
  "45.0603": "Econometrics and Quantitative Economics",
  "45.0604": "Development Economics and International Development",
  "45.0605": "International Economics",
  "45.0699": "Economics, Other",
  "45.0701": "Geography",
  "45.0702": "Geographic Information Science and Cartography",
  "45.0799": "Geography, Other",
  "45.0901": "International Relations and Affairs",
  "45.0902": "National Security Policy Studies",
  "45.0999": "International Relations and National Security Studies, Other",
  "45.1001": "Political Science and Government, General",
  "45.1002": "American Government and Politics (United States)",
  "45.1003": "Canadian Government and Politics",
  "45.1004": "Political Economy",
  "45.1099": "Political Science and Government, Other",
  "45.1101": "Sociology",
  "45.1201": "Urban Studies/Affairs",
  "45.1301": "Sociology and Anthropology",
  "45.1401": "Rural Sociology",
  "45.9999": "Social Sciences, Other",
  "46.0000": "Construction Trades, General",
  "46.0101": "Mason/Masonry",
  "46.0201": "Carpentry/Carpenter",
  "46.0301":
    "Electrical and Power Transmission Installation/Installer, General",
  "46.0302": "Electrician",
  "46.0303": "Lineworker",
  "46.0399": "Electrical and Power Transmission Installers, Other",
  "46.0401": "Building/Property Maintenance",
  "46.0402": "Concrete Finishing/Concrete Finisher",
  "46.0403": "Building/Home/Construction Inspection/Inspector",
  "46.0404": "Drywall Installation/Drywaller",
  "46.0406": "Glazier",
  "46.0408": "Painting/Painter and Wall Coverer",
  "46.0410": "Roofer",
  "46.0411": "Metal Building Assembly/Assembler",
  "46.0412": "Building/Construction Site Management/Manager",
  "46.0413": "Carpet, Floor, and Tile Worker",
  "46.0414": "Insulator",
  "46.0415": "Building Construction Technology",
  "46.0499":
    "Building/Construction Finishing, Management, and Inspection, Other",
  "46.0502": "Pipefitting/Pipefitter and Sprinkler Fitter",
  "46.0503": "Plumbing Technology/Plumber",
  "46.0504": "Well Drilling/Driller",
  "46.0505": "Blasting/Blaster",
  "46.0599": "Plumbing and Related Water Supply Services, Other",
  "46.9999": "Construction Trades, Other",
  "47.0000": "Mechanics and Repairers, General",
  "47.0101":
    "Electrical/Electronics Equipment Installation and Repair, General",
  "47.0102": "Business Machine Repair",
  "47.0103": "Communications Systems Installation and Repair Technology",
  "47.0104": "Computer Installation and Repair Technology/Technician",
  "47.0105": "Industrial Electronics Technology/Technician",
  "47.0106": "Appliance Installation and Repair Technology/Technician",
  "47.0110":
    "Security System Installation, Repair, and Inspection Technology/Technician",
  "47.0199": "Electrical/Electronics Maintenance and Repair Technology, Other",
  "47.0201":
    "Heating, Air Conditioning, Ventilation and Refrigeration Maintenance Technology/Technician",
  "47.0302": "Heavy Equipment Maintenance Technology/Technician",
  "47.0303": "Industrial Mechanics and Maintenance Technology",
  "47.0399": "Heavy/Industrial Equipment Maintenance Technologies, Other",
  "47.0402": "Gunsmithing/Gunsmith",
  "47.0403": "Locksmithing and Safe Repair",
  "47.0404": "Musical Instrument Fabrication and Repair",
  "47.0408": "Watchmaking and Jewelrymaking",
  "47.0409":
    "Parts and Warehousing Operations and Maintenance Technology/Technician",
  "47.0499": "Precision Systems Maintenance and Repair Technologies, Other",
  "47.0600": "Vehicle Maintenance and Repair Technologies, General",
  "47.0603": "Autobody/Collision and Repair Technology/Technician",
  "47.0604": "Automobile/Automotive Mechanics Technology/Technician",
  "47.0605": "Diesel Mechanics Technology/Technician",
  "47.0606": "Small Engine Mechanics and Repair Technology/Technician",
  "47.0607":
    "Airframe Mechanics and Aircraft Maintenance Technology/Technician",
  "47.0608": "Aircraft Powerplant Technology/Technician",
  "47.0609": "Avionics Maintenance Technology/Technician",
  "47.0610": "Bicycle Mechanics and Repair Technology/Technician",
  "47.0611": "Motorcycle Maintenance and Repair Technology/Technician",
  "47.0612":
    "Vehicle Emissions Inspection and Maintenance Technology/Technician",
  "47.0613": "Medium/Heavy Vehicle and Truck Technology/Technician",
  "47.0614": "Alternative Fuel Vehicle Technology/Technician",
  "47.0615": "Engine Machinist",
  "47.0616": "Marine Maintenance/Fitter and Ship Repair Technology/Technician",
  "47.0617": "High Performance and Custom Engine Technician/Mechanic",
  "47.0618": "Recreation Vehicle (RV) Service Technician",
  "47.0699": "Vehicle Maintenance and Repair Technologies, Other",
  "47.9999": "Mechanic and Repair Technologies/Technicians, Other",
  "48.0000": "Precision Production Trades, General",
  "48.0303": "Upholstery/Upholsterer",
  "48.0304": "Shoe, Boot and Leather Repair",
  "48.0399": "Leatherworking and Upholstery, Other",
  "48.0501": "Machine Tool Technology/Machinist",
  "48.0503": "Machine Shop Technology/Assistant",
  "48.0506": "Sheet Metal Technology/Sheetworking",
  "48.0507": "Tool and Die Technology/Technician",
  "48.0508": "Welding Technology/Welder",
  "48.0509": "Ironworking/Ironworker",
  "48.0510":
    "Computer Numerically Controlled (CNC) Machinist Technology/CNC Machinist",
  "48.0511": "Metal Fabricator",
  "48.0599": "Precision Metal Working, Other",
  "48.0701": "Woodworking, General",
  "48.0702": "Furniture Design and Manufacturing",
  "48.0703": "Cabinetmaking and Millwork",
  "48.0799": "Woodworking, Other",
  "48.0801": "Boilermaking/Boilermaker",
  "48.9999": "Precision Production, Other",
  "49.0101": "Aeronautics/Aviation/Aerospace Science and Technology, General",
  "49.0102": "Airline/Commercial/Professional Pilot and Flight Crew",
  "49.0104": "Aviation/Airway Management and Operations",
  "49.0105": "Air Traffic Controller",
  "49.0106": "Airline Flight Attendant",
  "49.0108": "Flight Instructor",
  "49.0199": "Air Transportation, Other",
  "49.0202": "Construction/Heavy Equipment/Earthmoving Equipment Operation",
  "49.0205": "Truck and Bus Driver/Commercial Vehicle Operator and Instructor",
  "49.0206": "Mobil Crane Operation/Operator",
  "49.0207": "Flagging and Traffic Control",
  "49.0208": "Railroad and Railway Transportation",
  "49.0299": "Ground Transportation, Other",
  "49.0303": "Commercial Fishing",
  "49.0304": "Diver, Professional and Instructor",
  "49.0309": "Marine Science/Merchant Marine Officer",
  "49.0399": "Marine Transportation, Other",
  "49.9999": "Transportation and Materials Moving, Other",
  "50.0101": "Visual and Performing Arts, General",
  "50.0102": "Digital Arts",
  "50.0201": "Crafts/Craft Design, Folk Art and Artisanry",
  "50.0301": "Dance, General",
  "50.0302": "Ballet",
  "50.0399": "Dance, Other",
  "50.0401": "Design and Visual Communications, General",
  "50.0402": "Commercial and Advertising Art",
  "50.0404": "Industrial and Product Design",
  "50.0406": "Commercial Photography",
  "50.0407": "Fashion/Apparel Design",
  "50.0408": "Interior Design",
  "50.0409": "Graphic Design",
  "50.0410": "Illustration",
  "50.0411": "Game and Interactive Media Design",
  "50.0499": "Design and Applied Arts, Other",
  "50.0501": "Drama and Dramatics/Theatre Arts, General",
  "50.0502": "Technical Theatre/Theatre Design and Technology",
  "50.0504": "Playwriting and Screenwriting",
  "50.0505": "Theatre Literature, History and Criticism",
  "50.0506": "Acting",
  "50.0507": "Directing and Theatrical Production",
  "50.0509": "Musical Theatre",
  "50.0510": "Costume Design",
  "50.0599": "Dramatic/Theatre Arts and Stagecraft, Other",
  "50.0601": "Film/Cinema/Video Studies",
  "50.0602": "Cinematography and Film/Video Production",
  "50.0605": "Photography",
  "50.0607": "Documentary Production",
  "50.0699": "Film/Video and Photographic Arts, Other",
  "50.0701": "Art/Art Studies, General",
  "50.0702": "Fine/Studio Arts, General",
  "50.0703": "Art History, Criticism and Conservation",
  "50.0705": "Drawing",
  "50.0706": "Intermedia/Multimedia",
  "50.0708": "Painting",
  "50.0709": "Sculpture",
  "50.0710": "Printmaking",
  "50.0711": "Ceramic Arts and Ceramics",
  "50.0712": "Fiber, Textile and Weaving Arts",
  "50.0713": "Metal and Jewelry Arts",
  "50.0799": "Fine Arts and Art Studies, Other",
  "50.0901": "Music, General",
  "50.0902": "Music History, Literature, and Theory",
  "50.0903": "Music Performance, General",
  "50.0904": "Music Theory and Composition",
  "50.0905": "Musicology and Ethnomusicology",
  "50.0906": "Conducting",
  "50.0907": "Keyboard Instruments",
  "50.0908": "Voice and Opera",
  "50.0910": "Jazz/Jazz Studies",
  "50.0911": "Stringed Instruments",
  "50.0912": "Music Pedagogy",
  "50.0913": "Music Technology",
  "50.0914": "Brass Instruments",
  "50.0915": "Woodwind Instruments",
  "50.0916": "Percussion Instruments",
  "50.0999": "Music, Other",
  "50.1001": "Arts, Entertainment,and Media Management, General",
  "50.1002": "Fine and Studio Arts Management",
  "50.1003": "Music Management",
  "50.1004": "Theatre/Theatre Arts Management",
  "50.1099": "Arts, Entertainment, and Media Management, Other",
  "50.9999": "Visual and Performing Arts, Other",
  "51.0000": "Health Services/Allied Health/Health Sciences, General",
  "51.0001": "Health and Wellness, General",
  "51.0101": "Chiropractic",
  "51.0201": "Communication Sciences and Disorders, General",
  "51.0202": "Audiology/Audiologist",
  "51.0203": "Speech-Language Pathology/Pathologist",
  "51.0204": "Audiology/Audiologist and Speech-Language Pathology/Pathologist",
  "51.0299": "Communication Disorders Sciences and Services, Other",
  "51.0401": "Dentistry",
  "51.0501": "Dental Clinical Sciences, General",
  "51.0502": "Advanced General Dentistry",
  "51.0503": "Oral Biology and Oral and Maxillofacial Pathology",
  "51.0504": "Dental Public Health and Education",
  "51.0505": "Dental Materials",
  "51.0506": "Endodontics/Endodontology",
  "51.0507": "Oral/Maxillofacial Surgery",
  "51.0508": "Orthodontics/Orthodontology",
  "51.0509": "Pediatric Dentistry/Pedodontics",
  "51.0510": "Periodontics/Periodontology",
  "51.0511": "Prosthodontics/Prosthodontology",
  "51.0599": "Advanced/Graduate Dentistry and Oral Sciences, Other",
  "51.0601": "Dental Assisting/Assistant",
  "51.0602": "Dental Hygiene/Hygienist",
  "51.0603": "Dental Laboratory Technology/Technician",
  "51.0699": "Dental Services and Allied Professions, Other",
  "51.0701": "Health/Health Care Administration/Management",
  "51.0702": "Hospital and Health Care Facilities Administration/Management",
  "51.0703": "Health Unit Coordinator/Ward Clerk",
  "51.0704": "Health Unit Manager/Ward Supervisor",
  "51.0705": "Medical Office Management/Administration",
  "51.0706": "Health Information/Medical Records Administration/Administrator",
  "51.0707": "Health Information/Medical Records Technology/Technician",
  "51.0708": "Medical Transcription/Transcriptionist",
  "51.0709": "Medical Office Computer Specialist/Assistant",
  "51.0710": "Medical Office Assistant/Specialist",
  "51.0711": "Medical/Health Management and Clinical Assistant/Specialist",
  "51.0712": "Medical Reception/Receptionist",
  "51.0713": "Medical Insurance Coding Specialist/Coder",
  "51.0714": "Medical Insurance Specialist/Medical Biller",
  "51.0715": "Health/Medical Claims Examiner",
  "51.0716": "Medical Administrative/Executive Assistant and Medical Secretary",
  "51.0717": "Medical Staff Services Technology/Technician",
  "51.0718": "Long Term Care Administration/Management",
  "51.0719": "Clinical Research Coordinator",
  "51.0799": "Health and Medical Administrative Services, Other",
  "51.0801": "Medical/Clinical Assistant",
  "51.0802": "Clinical/Medical Laboratory Assistant",
  "51.0803": "Occupational Therapist Assistant",
  "51.0805": "Pharmacy Technician/Assistant",
  "51.0806": "Physical Therapy Technician/Assistant",
  "51.0808":
    "Veterinary/Animal Health Technology/Technician and Veterinary Assistant",
  "51.0809": "Anesthesiologist Assistant",
  "51.0810": "Emergency Care Attendant (EMT Ambulance)",
  "51.0811": "Pathology/Pathologist Assistant",
  "51.0812": "Respiratory Therapy Technician/Assistant",
  "51.0813": "Chiropractic Assistant/Technician",
  "51.0814": "Radiologist Assistant",
  "51.0815": "Lactation Consultant",
  "51.0816": "Speech-Language Pathology Assistant",
  "51.0899": "Allied Health and Medical Assisting Services, Other",
  "51.0901": "Cardiovascular Technology/Technologist",
  "51.0902": "Electrocardiograph Technology/Technician",
  "51.0903":
    "Electroneurodiagnostic/Electroencephalographic Technology/Technologist",
  "51.0904": "Emergency Medical Technology/Technician (EMT Paramedic)",
  "51.0905": "Nuclear Medical Technology/Technologist",
  "51.0906": "Perfusion Technology/Perfusionist",
  "51.0907": "Medical Radiologic Technology/Science - Radiation Therapist",
  "51.0908": "Respiratory Care Therapy/Therapist",
  "51.0909": "Surgical Technology/Technologist",
  "51.0910":
    "Diagnostic Medical Sonography/Sonographer and Ultrasound Technician",
  "51.0911": "Radiologic Technology/Science - Radiographer",
  "51.0912": "Physician Assistant",
  "51.0913": "Athletic Training/Trainer",
  "51.0914": "Gene/Genetic Therapy",
  "51.0915": "Cardiopulmonary Technology/Technologist",
  "51.0916": "Radiation Protection/Health Physics Technician",
  "51.0917": "Polysomnography",
  "51.0918": "Hearing Instrument Specialist",
  "51.0919": "Mammography Technician/Technology",
  "51.0920": "Magnetic Resonance Imaging (MRI) Technology/Technician",
  "51.0999":
    "Allied Health Diagnostic, Intervention, and Treatment Professions, Other",
  "51.1001": "Blood Bank Technology Specialist",
  "51.1002": "Cytotechnology/Cytotechnologist",
  "51.1003": "Hematology Technology/Technician",
  "51.1004": "Clinical/Medical Laboratory Technician",
  "51.1005": "Clinical Laboratory Science/Medical Technology/Technologist",
  "51.1006": "Ophthalmic Laboratory Technology/Technician",
  "51.1007": "Histologic Technology/Histotechnologist",
  "51.1008": "Histologic Technician",
  "51.1009": "Phlebotomy Technician/Phlebotomist",
  "51.1010": "Cytogenetics/Genetics/Clinical Genetics Technology/Technologist",
  "51.1011": "Renal/Dialysis Technologist/Technician",
  "51.1012": "Sterile Processing Technology/Technician",
  "51.1099":
    "Clinical/Medical Laboratory Science and Allied Professions, Other",
  "51.1101": "Pre-Dentistry Studies",
  "51.1102": "Pre-Medicine/Pre-Medical Studies",
  "51.1103": "Pre-Pharmacy Studies",
  "51.1104": "Pre-Veterinary Studies",
  "51.1105": "Pre-Nursing Studies",
  "51.1106": "Pre-Chiropractic Studies",
  "51.1107": "Pre-Occupational Therapy Studies",
  "51.1108": "Pre-Optometry Studies",
  "51.1109": "Pre-Physical Therapy Studies",
  "51.1199": "Health/Medical Preparatory Programs, Other",
  "51.1201": "Medicine",
  "51.1401": "Medical Scientist",
  "51.1501": "Substance Abuse/Addiction Counseling",
  "51.1502": "Psychiatric/Mental Health Services Technician",
  "51.1503": "Clinical/Medical Social Work",
  "51.1504": "Community Health Services/Liaison/Counseling",
  "51.1505": "Marriage and Family Therapy/Counseling",
  "51.1506": "Clinical Pastoral Counseling/Patient Counseling",
  "51.1507": "Psychoanalysis and Psychotherapy",
  "51.1508": "Mental Health Counseling/Counselor",
  "51.1509": "Genetic Counseling/Counselor",
  "51.1599": "Mental and Social Health Services and Allied Professions, Other",
  "51.1701": "Optometry",
  "51.1801": "Opticianry/Ophthalmic Dispensing Optician",
  "51.1802": "Optometric Technician/Assistant",
  "51.1803": "Ophthalmic Technician/Technologist",
  "51.1804": "Orthoptics/Orthoptist",
  "51.1899":
    "Ophthalmic and Optometric Support Services and Allied Professions, Other",
  "51.1901": "Osteopathic Medicine/Osteopathy",
  "51.2001": "Pharmacy",
  "51.2002":
    "Pharmacy Administration and Pharmacy Policy and Regulatory Affairs",
  "51.2003": "Pharmaceutics and Drug Design",
  "51.2004": "Medicinal and Pharmaceutical Chemistry",
  "51.2005": "Natural Products Chemistry and Pharmacognosy",
  "51.2006": "Clinical and Industrial Drug Development",
  "51.2007": "Pharmacoeconomics/Pharmaceutical Economics",
  "51.2008": "Clinical, Hospital, and Managed Care Pharmacy",
  "51.2009": "Industrial and Physical Pharmacy and Cosmetic Sciences",
  "51.2010": "Pharmaceutical Sciences",
  "51.2011": "Pharmaceutical Marketing and Management",
  "51.2099": "Pharmacy, Pharmaceutical Sciences, and Administration, Other",
  "51.2101": "Podiatric Medicine/Podiatry",
  "51.2201": "Public Health, General",
  "51.2202": "Environmental Health",
  "51.2205": "Health/Medical  Physics",
  "51.2206": "Occupational Health and Industrial Hygiene",
  "51.2207": "Public Health Education and Promotion",
  "51.2208": "Community Health and Preventive Medicine",
  "51.2209": "Maternal and Child Health",
  "51.2210": "International Public Health/International Health",
  "51.2211": "Health Services Administration",
  "51.2212": "Behavioral Aspects of Health",
  "51.2299": "Public Health, Other",
  "51.2301": "Art Therapy/Therapist",
  "51.2302": "Dance Therapy/Therapist",
  "51.2305": "Music Therapy/Therapist",
  "51.2306": "Occupational Therapy/Therapist",
  "51.2307": "Orthotist/Prosthetist",
  "51.2308": "Physical Therapy/Therapist",
  "51.2309": "Therapeutic Recreation/Recreational Therapy",
  "51.2310": "Vocational Rehabilitation Counseling/Counselor",
  "51.2311": "Kinesiotherapy/Kinesiotherapist",
  "51.2312": "Assistive/Augmentative Technology and Rehabilitation Engineering",
  "51.2313": "Animal-Assisted Therapy",
  "51.2314": "Rehabilitation Science",
  "51.2399": "Rehabilitation and Therapeutic Professions, Other",
  "51.2401": "Veterinary Medicine",
  "51.2501": "Veterinary Sciences/Veterinary Clinical Sciences, General",
  "51.2502": "Veterinary Anatomy",
  "51.2503": "Veterinary Physiology",
  "51.2504": "Veterinary Microbiology and Immunobiology",
  "51.2505": "Veterinary Pathology and Pathobiology",
  "51.2506": "Veterinary Toxicology and Pharmacology",
  "51.2507": "Large Animal/Food Animal and Equine Surgery and Medicine",
  "51.2508": "Small/Companion Animal Surgery and Medicine",
  "51.2509": "Comparative and Laboratory Animal Medicine",
  "51.2510": "Veterinary Preventive Medicine, Epidemiology, and Public Health",
  "51.2511": "Veterinary Infectious Diseases",
  "51.2599": "Veterinary Biomedical and Clinical Sciences, Other",
  "51.2601": "Health Aide",
  "51.2602": "Home Health Aide/Home Attendant",
  "51.2603": "Medication Aide",
  "51.2604": "Rehabilitation Aide",
  "51.2699": "Health Aides/Attendants/Orderlies, Other",
  "51.2703": "Medical Illustration/Medical Illustrator",
  "51.2706": "Medical Informatics",
  "51.2799": "Medical Illustration and Informatics, Other",
  "51.3101": "Dietetics/Dietitian",
  "51.3102": "Clinical Nutrition/Nutritionist",
  "51.3103": "Dietetic Technician",
  "51.3104": "Dietitian Assistant",
  "51.3199": "Dietetics and Clinical Nutrition Services, Other",
  "51.3201": "Bioethics/Medical Ethics",
  "51.3300":
    "Alternative and Complementary Medicine and Medical Systems, General",
  "51.3301": "Acupuncture and Oriental Medicine",
  "51.3302": "Traditional Chinese Medicine and Chinese Herbology",
  "51.3303": "Naturopathic Medicine/Naturopathy",
  "51.3304": "Homeopathic Medicine/Homeopathy",
  "51.3305": "Ayurvedic Medicine/Ayurveda",
  "51.3306": "Holistic Health",
  "51.3399":
    "Alternative and Complementary Medicine and Medical Systems, Other",
  "51.3401": "Direct Entry Midwifery",
  "51.3499": "Alternative and Complementary Medical Support Services, Other",
  "51.3501": "Massage Therapy/Therapeutic Massage",
  "51.3502": "Asian Bodywork Therapy",
  "51.3503": "Somatic Bodywork",
  "51.3599": "Somatic Bodywork and Related Therapeutic Services, Other",
  "51.3601": "Movement Therapy and Movement Education",
  "51.3602": "Yoga Teacher Training/Yoga Therapy",
  "51.3603": "Hypnotherapy/Hypnotherapist",
  "51.3699": "Movement and Mind-Body Therapies and Education, Other",
  "51.3701": "Aromatherapy",
  "51.3702": "Herbalism/Herbalist",
  "51.3703": "Polarity Therapy",
  "51.3704": "Reiki",
  "51.3799": "Energy and Biologically Based Therapies, Other",
  "51.3801": "Registered Nursing/Registered Nurse",
  "51.3802": "Nursing Administration",
  "51.3803": "Adult Health Nurse/Nursing",
  "51.3804": "Nurse Anesthetist",
  "51.3805": "Family Practice Nurse/Nursing",
  "51.3806": "Maternal/Child Health and Neonatal Nurse/Nursing",
  "51.3807": "Nurse Midwife/Nursing Midwifery",
  "51.3808": "Nursing Science",
  "51.3809": "Pediatric Nurse/Nursing",
  "51.3810": "Psychiatric/Mental Health Nurse/Nursing",
  "51.3811": "Public Health/Community Nurse/Nursing",
  "51.3812": "Perioperative/Operating Room and Surgical Nurse/Nursing",
  "51.3813": "Clinical Nurse Specialist",
  "51.3814": "Critical Care Nursing",
  "51.3815": "Occupational and Environmental Health Nursing",
  "51.3816": "Emergency Room/Trauma Nursing",
  "51.3817": "Nursing Education",
  "51.3818": "Nursing Practice",
  "51.3819": "Palliative Care Nursing",
  "51.3820": "Clinical Nurse Leader",
  "51.3821": "Geriatric Nurse/Nursing",
  "51.3822": "Women's Health Nurse/Nursing",
  "51.3899":
    "Registered Nursing, Nursing Administration, Nursing Research and Clinical Nursing, Other",
  "51.3901": "Licensed Practical/Vocational Nurse Training",
  "51.3902": "Nursing Assistant/Aide and Patient Care Assistant/Aide",
  "51.3999":
    "Practical Nursing, Vocational Nursing and Nursing Assistants, Other",
  "51.9999": "Health Professions and Related Clinical Sciences, Other",
  "52.0101": "Business/Commerce, General",
  "52.0201": "Business Administration and Management, General",
  "52.0202": "Purchasing, Procurement/Acquisitions and Contracts Management",
  "52.0203": "Logistics, Materials, and Supply Chain Management",
  "52.0204": "Office Management and Supervision",
  "52.0205": "Operations Management and Supervision",
  "52.0206": "Non-Profit/Public/Organizational Management",
  "52.0207": "Customer Service Management",
  "52.0208": "E-Commerce/Electronic Commerce",
  "52.0209": "Transportation/Mobility Management",
  "52.0210": "Research and Development Management",
  "52.0211": "Project Management",
  "52.0212": "Retail Management",
  "52.0213": "Organizational Leadership",
  "52.0299": "Business Administration, Management and Operations, Other",
  "52.0301": "Accounting",
  "52.0302": "Accounting Technology/Technician and Bookkeeping",
  "52.0303": "Auditing",
  "52.0304": "Accounting and Finance",
  "52.0305": "Accounting and Business/Management",
  "52.0399": "Accounting and Related Services, Other",
  "52.0401": "Administrative Assistant and Secretarial Science, General",
  "52.0402": "Executive Assistant/Executive Secretary",
  "52.0406": "Receptionist",
  "52.0407": "Business/Office Automation/Technology/Data Entry",
  "52.0408": "General Office Occupations and Clerical Services",
  "52.0409": "Parts, Warehousing, and Inventory Management Operations",
  "52.0410": "Traffic, Customs, and Transportation Clerk/Technician",
  "52.0411": "Customer Service Support/Call Center/Teleservice Operation",
  "52.0499": "Business Operations Support and Secretarial Services, Other",
  "52.0501": "Business/Corporate Communications",
  "52.0601": "Business/Managerial Economics",
  "52.0701": "Entrepreneurship/Entrepreneurial Studies",
  "52.0702": "Franchising and Franchise Operations",
  "52.0703": "Small Business Administration/Management",
  "52.0799": "Entrepreneurial and Small Business Operations, Other",
  "52.0801": "Finance, General",
  "52.0803": "Banking and Financial Support Services",
  "52.0804": "Financial Planning and Services",
  "52.0806": "International Finance",
  "52.0807": "Investments and Securities",
  "52.0808": "Public Finance",
  "52.0809": "Credit Management",
  "52.0899": "Finance and Financial Management Services, Other",
  "52.0901": "Hospitality Administration/Management, General",
  "52.0903": "Tourism and Travel Services Management",
  "52.0904": "Hotel/Motel Administration/Management",
  "52.0905": "Restaurant/Food Services Management",
  "52.0906": "Resort Management",
  "52.0907": "Meeting and Event Planning",
  "52.0908": "Casino Management",
  "52.0909": "Hotel, Motel, and Restaurant Management",
  "52.0999": "Hospitality Administration/Management, Other",
  "52.1001": "Human Resources Management/Personnel Administration, General",
  "52.1002": "Labor and Industrial Relations",
  "52.1003": "Organizational Behavior Studies",
  "52.1004": "Labor Studies",
  "52.1005": "Human Resources Development",
  "52.1099": "Human Resources Management and Services, Other",
  "52.1101": "International Business/Trade/Commerce",
  "52.1201": "Management Information Systems, General",
  "52.1206": "Information Resources Management",
  "52.1207": "Knowledge Management",
  "52.1299": "Management Information Systems and Services, Other",
  "52.1301": "Management Science",
  "52.1302": "Business Statistics",
  "52.1304": "Actuarial Science",
  "52.1399": "Management Sciences and Quantitative Methods, Other",
  "52.1401": "Marketing/Marketing Management, General",
  "52.1402": "Marketing Research",
  "52.1403": "International Marketing",
  "52.1499": "Marketing, Other",
  "52.1501": "Real Estate",
  "52.1601": "Taxation",
  "52.1701": "Insurance",
  "52.1801": "Sales, Distribution, and Marketing Operations, General",
  "52.1802": "Merchandising and Buying Operations",
  "52.1803": "Retailing and Retail Operations",
  "52.1804": "Selling Skills and Sales Operations",
  "52.1899":
    "General Merchandising, Sales, and Related Marketing Operations, Other",
  "52.1901": "Auctioneering",
  "52.1902": "Fashion Merchandising",
  "52.1903": "Fashion Modeling",
  "52.1904": "Apparel and Accessories Marketing Operations",
  "52.1905": "Tourism and Travel Services Marketing Operations",
  "52.1906": "Tourism Promotion Operations",
  "52.1907": "Vehicle and Vehicle Parts and Accessories Marketing Operations",
  "52.1908": "Business and Personal/Financial Services Marketing Operations",
  "52.1909": "Special Products Marketing Operations",
  "52.1910": "Hospitality and Recreation Marketing Operations",
  "52.1999":
    "Specialized Merchandising, Sales, and Marketing Operations, Other",
  "52.2001": "Construction Management",
  "52.2101": "Telecommunications Management",
  "52.9999":
    "Business, Management, Marketing, and Related Support Services, Other",
  "53.0101": "Regular/General High School/Secondary Diploma Program",
  "53.0102":
    "College/University Preparatory and Advanced High School/Secondary Diploma Program",
  "53.0103":
    "Vocational High School and Secondary Business/Vocational-Industrial/Occupational Diploma Program",
  "53.0104": "Honors/Regents High School/Secondary Diploma Program",
  "53.0105": "Adult High School/Secondary Diploma Program",
  "53.0199": "High School/Secondary Diploma Programs, Other",
  "53.0201": "High School Equivalence Certificate Program",
  "53.0202": "High School Certificate of Competence Program",
  "53.0203": "Certificate of IEP Completion Program",
  "53.0299": "High School/Secondary Certificates, Other",
  "54.0101": "History, General",
  "54.0102": "American  History (United States)",
  "54.0103": "European History",
  "54.0104": "History and Philosophy of Science and Technology",
  "54.0105": "Public/Applied History",
  "54.0106": "Asian History",
  "54.0107": "Canadian History",
  "54.0108": "Military History",
  "54.0199": "History, Other",
  "60.0101": "Oral and Maxillofacial Surgery Residency Program",
  "60.0102": "Dental Public Health Residency Program",
  "60.0103": "Endodontics Residency Program",
  "60.0104": "Oral and Maxillofacial Pathology Residency Program",
  "60.0105": "Orthodontics Residency Program",
  "60.0106": "Pediatric Dentistry Residency Program",
  "60.0107": "Periodontology Residency Program",
  "60.0108": "Prosthodontics Residency Program",
  "60.0109": "Oral and Maxillofacial Radiology Residency Program",
  "60.0199": "Dental Residency Program, Other",
  "60.0301": "Veterinary Anesthesiology Residency Program",
  "60.0302": "Veterinary Dentistry Residency Program",
  "60.0303": "Veterinary Dermatology Residency Program",
  "60.0304":
    "Veterinary Emergency and Critical Care Medicine Residency Program",
  "60.0305": "Veterinary Internal Medicine Residency Program",
  "60.0306": "Laboratory Animal Medicine Residency Program",
  "60.0307": "Veterinary Microbiology Residency Program",
  "60.0308": "Veterinary Nutrition Residency Program",
  "60.0309": "Veterinary Ophthalmology Residency Program",
  "60.0310": "Veterinary Pathology Residency Program",
  "60.0311": "Veterinary Practice Residency Program",
  "60.0312": "Veterinary Preventive Medicine Residency Program",
  "60.0313": "Veterinary Radiology Residency Program",
  "60.0314": "Veterinary Surgery Residency Program",
  "60.0315": "Theriogenology Residency Program",
  "60.0316": "Veterinary Toxicology Residency Program",
  "60.0317": "Zoological Medicine Residency Program",
  "60.0318": "Poultry Veterinarian Residency Program",
  "60.0319": "Veterinary Behaviorist Residency Program",
  "60.0320": "Veterinary Clinical Pharmacology Residency Program",
  "60.0399": "Veterinary Residency Programs, Other",
  "60.0401": "Aerospace Medicine Residency Program",
  "60.0402": "Allergy and Immunology Residency Program",
  "60.0403": "Anesthesiology Residency Program",
  "60.0404": "Child Neurology Residency Program",
  "60.0405": "Clinical Biochemical Genetics Residency Program",
  "60.0406": "Clinical Cytogenetics Residency Program",
  "60.0407": "Clinical Genetics Residency Program",
  "60.0408": "Clinical Molecular Genetics Residency Program",
  "60.0409": "Colon and Rectal Surgery Residency Program",
  "60.0410": "Dermatology Residency Program",
  "60.0411": "Diagnostic Radiology Residency Program",
  "60.0412": "Emergency Medicine Residency Program",
  "60.0413": "Family Medicine Residency Program",
  "60.0414": "General Surgery Residency Program",
  "60.0415": "Internal Medicine Residency Program",
  "60.0416": "Neurological Surgery Residency Program",
  "60.0417": "Neurology Residency Program",
  "60.0418": "Nuclear Medicine Residency Program",
  "60.0419": "Obstetrics and Gynecology Residency Program",
  "60.0420": "Occupational Medicine Residency Program",
  "60.0421": "Ophthalmology Residency Program",
  "60.0422": "Orthopedic Surgery Residency Program",
  "60.0423": "Otolaryngology Residency Program",
  "60.0424": "Pathology Residency Program",
  "60.0425": "Pediatrics Residency Program",
  "60.0426": "Physical Medicine and Rehabilitation Residency Program",
  "60.0427": "Plastic Surgery Residency Program",
  "60.0428": "Psychiatry Residency Program",
  "60.0429": "Public Health and General Preventive Medicine Residency Program",
  "60.0430": "Radiation Oncology Residency Program",
  "60.0431": "Radiologic Physics Residency Program",
  "60.0432": "Thoracic Surgery Residency Program",
  "60.0433": "Urology Residency Program",
  "60.0434": "Vascular Surgery Residency Program",
  "60.0499": "Medical Residency Programs - General Certificates, Other",
  "60.0501": "Addiction Psychiatry Residency Program",
  "60.0502": "Adolescent Medicine Residency Program",
  "60.0503": "Blood Banking/Transfusion Medicine Residency Program",
  "60.0504": "Cardiovascular Disease Residency Program",
  "60.0505": "Chemical Pathology Residency Program",
  "60.0506": "Child Abuse Pediatrics Residency Program",
  "60.0507": "Child and Adolescent Psychiatry Residency Program",
  "60.0508": "Clinical Cardiac Electrophysiology Residency Program",
  "60.0509": "Clinical Neurophysiology Residency Program",
  "60.0510": "Congenital Cardiac Surgery Residency Program",
  "60.0511": "Critical Care Medicine Residency Program",
  "60.0512": "Cytopathology Residency Program",
  "60.0513": "Dermatopathology Residency Program",
  "60.0514": "Developmental-Behavioral Pediatrics Residency Program",
  "60.0515": "Diagnostic Radiologic Physics Residency Program",
  "60.0516": "Endocrinology, Diabetes and Metabolism Residency Program",
  "60.0517": "Forensic Pathology Residency Program",
  "60.0518": "Forensic Psychiatry Residency Program",
  "60.0519": "Gastroenterology Residency Program",
  "60.0520": "Geriatric Medicine Residency Program",
  "60.0521": "Geriatric Psychiatry Residency Program",
  "60.0522": "Gynecologic Oncology Residency Program",
  "60.0523": "Hematological Pathology Residency Program",
  "60.0524": "Hematology Residency Program",
  "60.0525": "Hospice and Palliative Medicine Residency Program",
  "60.0526": "Immunopathology Residency Program",
  "60.0527": "Infectious Disease Residency Program",
  "60.0528": "Interventional Cardiology Residency Program",
  "60.0529": "Laboratory Medicine Residency Program",
  "60.0530": "Maternal and Fetal Medicine Residency Program",
  "60.0531": "Medical Biochemical Genetics Residency Program",
  "60.0532": "Medical Microbiology Residency Program",
  "60.0533": "Medical Nuclear Physics Residency Program",
  "60.0534": "Medical Oncology Residency Program",
  "60.0535": "Medical Toxicology Residency Program",
  "60.0536": "Molecular Genetic Pathology Residency Program",
  "60.0537": "Musculoskeletal Oncology Residency Program",
  "60.0538": "Neonatal-Perinatal Medicine Residency Program",
  "60.0539": "Nephrology Residency Program",
  "60.0540": "Neurodevelopmental Disabilities Residency Program",
  "60.0541": "Neuromuscular Medicine Residency Program",
  "60.0542": "Neuropathology Residency Program",
  "60.0543": "Neuroradiology Residency Program",
  "60.0544": "Neurotology Residency Program",
  "60.0545": "Nuclear Radiology Residency Program",
  "60.0546": "Orthopedic Sports Medicine Residency Program",
  "60.0547": "Orthopedic Surgery of the Spine Residency Program",
  "60.0548": "Pain Medicine Residency Program",
  "60.0549": "Pediatric Cardiology Residency Program",
  "60.0550": "Pediatric Critical Care Medicine Residency Program",
  "60.0551": "Pediatric Dermatology Residency Program",
  "60.0552": "Pediatric Emergency Medicine Residency Program",
  "60.0553": "Pediatric Endocrinology Residency Program",
  "60.0554": "Pediatric Gastroenterology Residency Program",
  "60.0555": "Pediatric Hematology-Oncology Residency Program",
  "60.0556": "Pediatric Infectious Diseases Residency Program",
  "60.0557": "Pediatric Nephrology Residency Program",
  "60.0558": "Pediatric Orthopedics Residency Program",
  "60.0559": "Pediatric Otolaryngology Residency Program",
  "60.0560": "Pediatric Pathology Residency Program",
  "60.0561": "Pediatric Pulmonology Residency Program",
  "60.0562": "Pediatric Radiology Residency Program",
  "60.0563": "Pediatric Rehabilitation Medicine Residency Program",
  "60.0564": "Pediatric Rheumatology Residency Program",
  "60.0565": "Pediatric Surgery Residency Program",
  "60.0566": "Pediatric Transplant Hepatology Residency Program",
  "60.0567": "Pediatric Urology Residency Program",
  "60.0568":
    "Physical Medicine and Rehabilitation/Psychiatry Residency Program",
  "60.0569": "Plastic Surgery Within the Head and Neck Residency Program",
  "60.0570": "Psychosomatic Medicine Residency Program",
  "60.0571": "Pulmonary Disease Residency Program",
  "60.0572": "Radioisotopic Pathology Residency Program",
  "60.0573": "Reproductive Endocrinology/Infertility Residency Program",
  "60.0574": "Rheumatology Residency Program",
  "60.0575": "Sleep Medicine Residency Program",
  "60.0576": "Spinal Cord Injury Medicine Residency Program",
  "60.0577": "Sports Medicine Residency Program",
  "60.0578": "Surgery of the Hand Residency Program",
  "60.0579": "Surgical Critical Care Residency Program",
  "60.0580": "Therapeutic Radiologic Physics Residency Program",
  "60.0581": "Transplant Hepatology Residency Program",
  "60.0582": "Undersea and Hyperbaric Medicine Residency Program",
  "60.0583": "Vascular and Interventional Radiology Residency Program",
  "60.0584": "Vascular Neurology Residency Program",
  "60.0599": "Medical Residency Programs - Subspecialty Certificates, Other",
  "60.0601": "Podiatric Medicine and Surgery - 24 Residency Program",
  "60.0602": "Podiatric Medicine and Surgery - 36 Residency Program"
}
